import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import React, { Dispatch, FunctionComponent } from 'react';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { Action } from 'redux';
import { ItineraryStatus } from '../../models/itinerary';
import { AppState } from '../../store/model';
import { combinationInit } from '../../store/reducers/itinerary/actions';
import { getStatus } from '../../store/reducers/itinerary/selectors';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';

interface OwnProps {
  isSelected?: boolean;
  priceText: string;
  isLastFlight?: boolean;
}

interface StateProps {
  status?: ItineraryStatus;
}

interface DispatchProps {
  runInit: void;
}

interface AirTotalPriceProps
  extends OwnProps,
    StateProps,
    DispatchProps,
    WithStyles<typeof styles>,
    InjectedIntlProps {}

const _AirTotalPriceBase: FunctionComponent<AirTotalPriceProps> = ({
  priceText,
  classes,
  isSelected,
  isLastFlight,
}) => {
  return (
    <Grid
      className={classNames(classes.mainWarp, {
        [classes.backgroundColorSelected]: isSelected,
        [classes.borderRight]: isLastFlight,
      })}
    >
      <Grid className={classes.priceTextWarp}>
        <Typography className={classes.priceText}>{priceText}</Typography>
      </Grid>
    </Grid>
  );
};

const styles = () => {
  return createStyles({
    mainWarp: {
      width: '233px',
      height: '50px',
      padding: 10,
      justifyContent: 'center',
      alignItems: 'center',
      display: 'inline-flex',
      boxSizing: 'border-box',
      borderTop: '1px #E0E0E0 solid',
      borderLeft: '1px #E0E0E0 solid',
      backgroundColor: 'white',
    },
    borderRight: { borderRight: '1px #E0E0E0 solid' },
    priceTextWarp: {
      flex: '1 1 0',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      display: 'inline-flex',
    },
    priceText: {
      color: 'rgba(0, 0, 0, 0.87)',
      fontSize: 16,
      fontFamily: 'Roboto Medium',
      fontWeight: 500,
      lineHeight: 28,
      letterSpacing: 0.15,
      wordWrap: 'break-word',
    },
    backgroundColorSelected: {
      backgroundColor: '#F5F5F5',
    },
  });
};

const mapStateToProps = (state: AppState): StateProps => {
  return {
    status: getStatus(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  runInit: () => {
    dispatch(combinationInit());
  },
});

const enhance = compose<AirTotalPriceProps, OwnProps>(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withStyles(styles),
  injectIntl,
);

export const AirTotalPrice = enhance(_AirTotalPriceBase);

AirTotalPrice.displayName = 'AirTotalPrice';
